import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    selectCurrencies,
    selectPreferredCurrency,
    setPreferredCurrency
} from 'tradera-state/multi-currency';
import Flag from 'tradera-components/flag/flag';
import { mapCurrencyCodeToCountryCode } from 'tradera-utils/map-currency-code-to-country-code';
import styles from './currency-select.module.scss';
import { useTranslator } from 'tradera-lang/translate';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';

export const PlainCurrencySelect = ({
    currencies,
    preferredCurrency,
    onCurrencySelected,
    onBlur,
    inProfileMenu
}) => {
    const { t } = useTranslator();
    return (
        <div className="pb-1">
            {!inProfileMenu && (
                <div className="ml-2 py-1">
                    <strong>{t('siteHeader_currency')}</strong>
                </div>
            )}
            {currencies.map(({ code, shortName, longName }) => (
                <button
                    className={`btn btn-fluid btn-hover-branded ${
                        styles.row
                    } d-flex py-1 ${inProfileMenu ? 'pl-4' : ''}`}
                    key={code}
                    onClick={e => {
                        onCurrencySelected(code, e);
                        onBlur();
                    }}>
                    <span className={inProfileMenu ? 'pl-3' : ''}>
                        <Flag
                            countryCodeIso2={mapCurrencyCodeToCountryCode(code)}
                            className="mr-1"
                        />
                        {preferredCurrency.code === code ? (
                            <strong>
                                {shortName} - {longName}
                            </strong>
                        ) : (
                            <>
                                {shortName} - {longName}
                            </>
                        )}
                    </span>
                    {preferredCurrency.code === code && (
                        <CheckIcon className="icon position-relative ml-auto" />
                    )}
                </button>
            ))}
        </div>
    );
};

PlainCurrencySelect.propTypes = {
    currencies: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            shortName: PropTypes.string,
            longName: PropTypes.string
        })
    ),
    preferredCurrency: PropTypes.shape({
        code: PropTypes.string
    }),
    onCurrencySelected: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    inProfileMenu: PropTypes.bool
};

const mapStateToProps = state => ({
    currencies: selectCurrencies(state),
    preferredCurrency: selectPreferredCurrency(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onCurrencySelected: (code, e) => {
        dispatch(setPreferredCurrency(code));
        ownProps.onCurrencySelected && ownProps.onCurrencySelected(code, e);
    }
});

export const CurrencySelect = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlainCurrencySelect);
